import React, { useEffect } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'

import { CONTAINER_IDS } from '../../../../lib/constants'
import { setScrollPosition } from '../../../../lib/utils'
import actions from './actions'
import Button from '../../../Button'
import CollectionListItem from '../../../CollectionListItem'
import CreateCollectionsModal from '../../../Modals/CreateCollectionModal'
import ghAnalytics from '../../../../lib/analytics'
import GHAnimatedLogo from '../../../../assets/svg/GHAnimatedLogo'
import Loader from '../../../Loader'
import NoUserData from './NoUserData'
import SidebarBody from '../../SidebarBody'
import styles from './SavedHunt.module.scss'

function SavedHuntTabContent(props) {
  useEffect(() => {
    props.setHasScrollBar(CONTAINER_IDS.sidebarBody)
    if (props.scrollPosition) {
      setScrollPosition(props.scrollPosition)
    }
  }, [props.isLoading, props.isLoadingMoreCollections])

  const createCollectionsModal = e => {
    props.displayModal(CreateCollectionsModal)
    ghAnalytics.logCollectionStarted()
  }

  return (
    <>
      {props.isLoadingMoreCollections ? (
        <div className={styles.ghLoader}>
          <GHAnimatedLogo width={72} height={108} />
          <p>Loading hunts...</p>
        </div>
      ) : (
        <>
          <div className={styles.createBar}>
            <Button disabled={props.isDisabled} onClick={createCollectionsModal} theme={Button.THEME.outlinePrimary}>
              Create New Hunt
            </Button>
          </div>
          <div className={styles.listHeader} />
          <SidebarBody className={`${styles.bodyContainer} ${props.hasScrollBar && styles.scrollBar}`}>
            {props.isLoading ? (
              <div className={styles.loader}>
                <Loader active={true} />
                {props.loaderText}
              </div>
            ) : props.collectionsList.length > 0 ? (
              props.collectionsList.map((cl, i) => {
                return <CollectionListItem active={cl.active} collection={cl} key={i} onClick={() => props.collectionClicked(cl)} />
              })
            ) : (
              <NoUserData {...props} />
            )}
          </SidebarBody>
        </>
      )}
    </>
  )
}

SavedHuntTabContent.propTypes = {
  collectionsList: PropTypes.array,
  hasScrollBar: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isLoadingMoreCollections: PropTypes.bool,
  loaderText: PropTypes.string,
  scrollPosition: PropTypes.string,
  // actions
  createCollectionsModal: PropTypes.func,
  displayModal: PropTypes.func,
  collectionClicked: PropTypes.func,
  gotoSidebarWithHistory: PropTypes.func,
  setHasScrollBar: PropTypes.func
}

export default connect(model => {
  const { collectionsList, collectionsLoading, moreCollectionsLoading: isLoadingMoreCollections, preferences } = model.collections
  const { sidebarHasScrollBar, sideBarScrollPosition } = model.app
  const hasScrollBar = sidebarHasScrollBar
  const isLoading = collectionsLoading || isLoadingMoreCollections
  const isDisabled = isLoading || isLoadingMoreCollections
  const loaderText = 'Loading Hunts...'
  const scrollPosition = sideBarScrollPosition.hunts

  /*
   * Derive `active` from the pinned uuid on every pass, into copies — never write it back
   * onto the store objects. Recomputing only when something was pinned left a stale
   * `active: true` on the previously pinned hunt once it was unpinned, so the list kept
   * showing it as active until the collections were refetched on reload.
   */
  let orderedCollections = collectionsList
  if (!isLoading && collectionsList.length > 0) {
    const pinnedUuid = preferences.pinned
    let pinnedIndex = -1
    orderedCollections = []

    for (let li = 0; li < collectionsList.length; li++) {
      const collection = collectionsList[li]
      const active = pinnedUuid != null && collection.uuid === pinnedUuid
      if (active) {
        pinnedIndex = li
      }
      orderedCollections.push({ ...collection, active })
    }

    if (pinnedIndex > 0) {
      orderedCollections.unshift(orderedCollections.splice(pinnedIndex, 1)[0])
    }
  }

  return {
    collectionsList: orderedCollections,
    collectionsLoading,
    hasScrollBar,
    scrollPosition,
    isDisabled,
    isLoading,
    isLoadingMoreCollections,
    loaderText
  }
}, actions)(SavedHuntTabContent)
